import React, { useState } from "react";
import Sidebar from "../../../../component/Navigation/Sidebar/Sidebar";
import "./CreateBulkTagComponent.css";
import CloudUploadIcon from "../../../../assests/UPLOADICON.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const CreateBulkTagComponent = ({
  corporateId,
  currentView,
  uploading,
  uploadProgress,
  uploadResult,
  uploadedData,
  onFileUpload,
  onBackClick,
  onAddMoreTags,
  onGoToDashboard,
  onRetry,
  onToggleTagSelection,
  onActivateSelectedTags,
  selectedTags,
  showSuccessPopup,
  onPopupOk,
  activateLoading,
  showActivateSuccessPopup,
  activateResult,
  onCloseActivatePopup,
  bulkUploadHeading,
  onFileSelect,
  onCancelFile
}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (file) => {
    if (!file) return;
    
    if (file.type !== "text/csv" && !file.name.endsWith('.csv')) {
      alert("Please upload a CSV file only");
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) {
      alert("File size should be less than 5MB");
      return;
    }
    
    setSelectedFile(file);
    // Trigger the file select callback to change heading
    if (onFileSelect) onFileSelect(file);
  };

  const handleUploadClick = () => {
    if (selectedFile) {
      onFileUpload(selectedFile);
      setSelectedFile(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    handleFileSelect(file);
  };

  const clearFile = () => {
    setSelectedFile(null);
    if (onCancelFile) onCancelFile();
  };

  const totalTags = uploadedData?.reduce((sum, dept) => sum + (dept.tags?.length || 0), 0) || 0;
  const selectedCount = Object.keys(selectedTags || {}).length;
  const allSelected = selectedCount === totalTags && totalTags > 0;

  const handleSelectAll = () => {
    const allTagIds = {};
    uploadedData?.forEach(dept => {
      dept.tags.forEach(tag => {
        allTagIds[tag.id] = tag;
      });
    });
    if (allSelected) {
      onToggleTagSelection(null, 'clear');
    } else {
      onToggleTagSelection(allTagIds, 'all');
    }
  };

  // ========== RENDER UPLOAD VIEW ==========
  const renderUploadView = () => (
    <div style={{ width: "80vw", backgroundColor: "#fff", margin: "auto", height: "85vh", alignContent: "center" }}>
      
      <div className="bulk-tag-upload-main-section">
        {uploading && (
          <div className="bulk-tag-upload-progress-container">
            <p style={{ fontSize: "25px", fontWeight: "500" }}>{bulkUploadHeading || "Upload Tag in bulk"}</p>
            <div className="bulk-tag-progress-bar">
              <div className="bulk-tag-progress-fill" style={{ width: `${uploadProgress}%` }}></div>
            </div>
            <p>Uploading... {uploadProgress}%</p>
          </div>
        )}
        
        {selectedFile && !uploading && (
          <div>
            <p style={{ fontSize: "25px", fontWeight: "500" }}>{bulkUploadHeading || "Upload"}</p>
            <div className="bulk-tag-file-preview">
              <div className="bulk-tag-file-info">
                <span className="bulk-tag-file-name">{selectedFile.name}</span>
                <span className="bulk-tag-file-size">({(selectedFile.size / 1024).toFixed(1)} MB)</span>
                <button onClick={clearFile} className="bulk-tag-remove-file">
                  <CloseIcon />
                </button>
              </div>
            </div>
            <div className="bulk-tag-file-actions">
              <button onClick={clearFile} className="bulk-tag-cancel-btn">Cancel</button>
              <button onClick={handleUploadClick} className="bulk-tag-upload-btn">Upload</button>
            </div>
          </div>
        )}

        {!selectedFile && !uploading && (
          <div 
            className="bulk-tag-drop-zone"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <input
              type="file"
              id="bulk-tag-csv-upload"
              accept=".csv"
              onChange={(e) => handleFileSelect(e.target.files[0])}
              style={{ display: 'none' }}
            />
            <img src={CloudUploadIcon} className="bulk-tag-upload-icon" />
            <p className="bulk-tag-upload-text">Drag & drop CSV file here</p>
            <p className="bulk-tag-upload-or">or</p>
            <label htmlFor="bulk-tag-csv-upload" className="bulk-tag-browse-btn">
              Browse File
            </label>
            <p className="bulk-tag-upload-hint">Supported format: CSV only </p>
          </div>
        )}
      </div>
    </div>
  );

  // ========== SUCCESS POPUP ==========
  const renderSuccessPopup = () => (
    <div className="bulk-tag-popup-overlay">
      <div className="bulk-tag-success-popup">
        <div className="bulk-tag-popup-icon">
          <CheckCircleIcon />
        </div>
        <h2>Successful</h2>
        <p>File Uploaded Successfully</p>
        <button className="bulk-tag-popup-ok-btn" onClick={onPopupOk}>
          Ok
        </button>
      </div>
    </div>
  );

  // ========== ACTIVATE SUCCESS POPUP ==========
  const renderActivateSuccessPopup = () => (
    <div className="bulk-tag-popup-overlay">
      <div className={`bulk-tag-result-popup ${activateResult?.success ? 'success' : 'error'}`}>
        <div className="bulk-tag-result-icon">
          {activateResult?.success ? (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" fill="#4CAF50" />
              <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" fill="#f44336" />
              <path d="M12 8L12 16M8 12L16 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </div>
        <h2>{activateResult?.success ? "Activation Successful!" : "Activation Failed"}</h2>
        {activateResult?.success ? (
          <div className="bulk-tag-result-details">
            <p>Successfully activated <strong>{activateResult.successCount}</strong> out of <strong>{activateResult.totalCount}</strong> tags</p>
            {activateResult.failureCount > 0 && (
              <div className="bulk-tag-failed-details">
                <p className="bulk-tag-warning-text">Failed tags ({activateResult.failureCount}):</p>
                <div className="bulk-tag-failed-list">
                  {activateResult.failedDetails?.slice(0, 10).map((item, idx) => (
                    <span key={idx} className="bulk-tag-failed-item">{item.uid || item}</span>
                  ))}
                  {activateResult.failedDetails?.length > 10 && (
                    <span className="bulk-tag-failed-item">+{activateResult.failedDetails.length - 10} more</span>
                  )}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="bulk-tag-result-details">
            <p>{activateResult?.message}</p>
            <p>Total tags attempted: <strong>{activateResult?.totalCount}</strong></p>
          </div>
        )}
        <button className="bulk-tag-result-ok-btn" onClick={onCloseActivatePopup}>
          OK
        </button>
      </div>
    </div>
  );

  // ========== RENDER TAGS VIEW ==========
  const renderTagsView = () => {
    return (
      <>
        <div className="bulk-tag-scrollable-departments">
          <div className="bulk-tag-departments-wrapper">
            {uploadedData?.map((department, deptIndex) => {
              const deptId = department.department_id !== undefined ? department.department_id : deptIndex;
              const deptName = department.department_name || `Department ${deptId}`;
              const tags = department.tags || [];
              const allDeptSelected = tags.length > 0 && tags.every(tag => selectedTags?.[tag.id]);
              
              return (
                <div key={deptIndex} className="bulk-tag-department-card">
                  <div className="bulk-tag-department-header">
                    <div className="bulk-tag-department-info">
                      <h4>{deptName}</h4>
                      <span className="bulk-tag-tag-count-badge">({tags.length} Tags)</span>
                    </div>
                    <div 
                      className="bulk-tag-dept-select-all"
                      onClick={() => {
                        const deptTags = {};
                        tags.forEach(tag => {
                          deptTags[tag.id] = tag;
                        });
                        if (allDeptSelected) {
                          onToggleTagSelection(null, 'clear');
                        } else {
                          onToggleTagSelection(deptTags, 'department');
                        }
                      }}
                    >
                      {allDeptSelected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                      <span>Select All</span>
                    </div>
                  </div>
                  
                  <div className="bulk-tag-tags-grid">
                    {tags.map((tag, tagIndex) => (
                      <div key={tagIndex} className="bulk-tag-tag-card">
                        <div className="bulk-tag-tag-content">
                          <div className="bulk-tag-tag-field">
                            <div className="bulk-tag-field-label">
                              <span>Tag ID</span>
                            </div>
                            <div className="bulk-tag-field-value">{tag.uid}</div>
                          </div>
                          <div className="bulk-tag-tag-field">
                            <div className="bulk-tag-field-label">
                              <span>Token</span>
                            </div>
                            <div className="bulk-tag-field-value">{tag.token}</div>
                          </div>
                        </div>
                        <div className="bulk-tag-tag-checkbox">
                          <input
                            type="checkbox"
                            checked={!!selectedTags?.[tag.id]}
                            onChange={() => onToggleTagSelection({ [tag.id]: tag }, 'single')}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bulk-tag-fixed-footer">
          <div className="bulk-tag-action-buttons-container">
            <button className="bulk-tag-add-more-btn" onClick={onAddMoreTags}>
              + Add More Tags
            </button>
            <button 
              className="bulk-tag-activate-btn" 
              onClick={() => onActivateSelectedTags(selectedTags)}
              disabled={selectedCount === 0 || activateLoading}
            >
              {activateLoading ? "Activating..." : `Activate Selected (${selectedCount})`}
            </button>
          </div>
        </div>
      </>
    );
  };

  // ========== RENDER ERROR VIEW ==========
  const renderErrorView = () => (
    <div className="bulk-tag-error-view-container">
      <div className="bulk-tag-error-card">
        <div className="bulk-tag-error-icon">
          <ErrorIcon />
        </div>
        <h2>Upload Failed</h2>
        <p>{uploadResult?.message || "Something went wrong. Please try again."}</p>
        <div className="bulk-tag-error-actions">
          <button className="bulk-tag-retry-btn" onClick={onRetry}>
            Try Again
          </button>
          <button className="bulk-tag-back-to-dashboard" onClick={onGoToDashboard}>
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bulk-tag-main-container">
      <Sidebar />
      
      <div className="bulk-tag-main-content">
        <div className="bulk-tag-top-header">
          <div className="bulk-tag-header">
            <div style={{ display: "flex", alignContent: "center", alignItems: "center" }}>
              <button onClick={onBackClick} className="bulk-tag-back-button">
                ←
              </button>
              <h1>Add and Activate Tags</h1>
            </div>
            {currentView === 'success' && (
              <div className="bulk-tag-select-all-top" onClick={handleSelectAll}>
                <span className="bulk-tag-select-all-icon">
                  {allSelected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                </span>
                <span className="bulk-tag-select-all-text">Select All ({selectedCount}/{totalTags})</span>
              </div>
            )}
          </div>
        </div>

        {currentView === 'upload' && renderUploadView()}
        {currentView === 'error' && renderErrorView()}
        {currentView === 'success' && renderTagsView()}
        
        {showSuccessPopup && renderSuccessPopup()}
        {showActivateSuccessPopup && renderActivateSuccessPopup()}
      </div>
    </div>
  );
};

export default CreateBulkTagComponent;